import API_BASE_URL from '../config/api';

const UPLOADS_PATH_REGEX = /^\/?uploads(\/.*)$/;

function getApiBase() {
  const base = API_BASE_URL.trim();
  if (!base) return '/api';
  return base.endsWith('/api') ? base : `${base.replace(/\/+$/, '')}/api`;
}

function getApiOrigin() {
  const apiBase = getApiBase();
  try {
    const url = new URL(apiBase, typeof window !== 'undefined' ? window.location.origin : undefined);
    return url.origin;
  } catch {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
}

const API_UPLOADS_BASE = `${getApiBase().replace(/\/$/, '')}/uploads`;
const API_ORIGIN = getApiOrigin();

export default function normalizeImageUrl(raw?: string | null): string | undefined {
  if (!raw) return undefined;
  try {
    const s = String(raw).trim();

    // Keep data:, blob:, and protocol-relative URLs as-is
    if (s.startsWith('data:') || s.startsWith('blob:') || s.startsWith('//')) return s;

    const uploadsMatch = s.match(UPLOADS_PATH_REGEX);
    if (uploadsMatch) {
      const url = new URL(s, typeof window !== 'undefined' ? window.location.origin : undefined);
      return `${API_UPLOADS_BASE}${uploadsMatch[1]}${url.search}${url.hash}`;
    }

    let url: URL;
    try {
      url = new URL(s, typeof window !== 'undefined' ? window.location.origin : undefined);
    } catch (_) {
      return s;
    }

    const normalizedPath = url.pathname.replace(/^\/api/, '');
    const isLocalUpload = normalizedPath.startsWith('/uploads/');
    const sameOrigin = url.origin === API_ORIGIN || url.origin === (typeof window !== 'undefined' ? window.location.origin : '');

    if (isLocalUpload && (sameOrigin || url.hostname === 'localhost' || url.hostname === '127.0.0.1')) {
      return `${API_UPLOADS_BASE}${normalizedPath.replace(/^\/uploads/, '')}${url.search}${url.hash}`;
    }

    return s;
  } catch (e) {
    return raw as any;
  }
}
